import { AntragUiData } from './antrag-ui-data.interface';

export interface AntragsOverviewJsonData {
  [key: string]: { icon: string; cssClass: string };
}

export function readFromJson(jsonData: AntragsOverviewJsonData): Map<number, AntragUiData> {
  const uiMap = new Map<number, AntragUiData>();

  Object.keys(jsonData).forEach((value) => uiMap.set(Number(value), jsonData[value]));

  return uiMap;
}
